import { useAnchorAgreementInfoContext } from './AnchorAgreementInfoContext';

const useAnchorAgreementInfoViewModel = () => {
  const { anchorAgreementInfo, updateAnchorAgreementInfo, fetchAnchorAgreementDetail, updateAnchorAgreementDetail } =
    useAnchorAgreementInfoContext();

  return {
    anchorAgreementInfo,
    updateAnchorAgreementInfo,
    fetchAnchorAgreementDetail,
    updateAnchorAgreementDetail,
  };
};

export default useAnchorAgreementInfoViewModel;
